import  router   from '@/router';

// 详情页方法
export const szzy = {
	goDetail:(bsid,id,index,type) => {
		/* 
			bsid： 1:视频，2：ppt,3:pdf 5示范课   
			index：导航选中
			type：1：思政库资源   2：后台新建资源
		 */
		if(bsid == 5){
			// 示范课
			router.push({
				path:"/sfk_play",
				query:{
					bsid:bsid,
					id:id,
					index:index,
					type:type
				}
			})
		}else if(bsid == 10){
			// 新闻
			router.push({
				path:"/news_play",
				query:{
					id:id,
					index:index
				}
			})
		}else{
			router.push({
				path:"/resource_play",
				query:{
					bsid:bsid,
					id:id,
					index:index,
					type:type
				}
			})
		}
	}
}